import * as React from 'react';

import Toolbar from "material-ui/Toolbar/Toolbar";
import ToolbarTitle from "material-ui/Toolbar/ToolbarTitle";

import HelpIcon from "material-ui/svg-icons/action/help-outline";
import UndoIcon from "material-ui/svg-icons/content/undo";
import RedoIcon from "material-ui/svg-icons/content/redo";

import Logo from "../../components/Logo";
import ActionBarOptions from "../interfaces/ActionBarOptions";
import Tabs from "../../custom-components/tabs/Tabs";
import Tab from "material-ui/Tabs/Tab";

import IconTextButton from '../../custom-components/icon-text-button/IconTextButton';
import FeedbackButton from '../../feedback/FeedbackButton';
import l10n from '../../util/l10n';

import { autoprefixer } from "../../material-ui/autoprefixer";

interface ActionBarToolbarProps extends React.Props<ActionBarToolbar>, ActionBarOptions {
    undoEnabled: boolean;
    redoEnabled: boolean;
    currentTab: number;
    onTabChange?(value: number): void;
}

class ActionBarToolbar extends React.Component<ActionBarToolbarProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <Toolbar style={styles.root}>
                <div key="logo" style={styles.logoToolbarGroup}>
                    <div style={styles.logoWrapper}>
                        <Logo style={styles.logo} />
                    </div>
                    {
                        this.props.titleText
                          ? ( <ToolbarTitle text={this.props.titleText} style={styles.title} /> )
                          : null
                    }
                    {
                        this.props.tabs
                          ? this.renderTabs()
                          : null
                    }
                </div>
                <div key="spacer1" style={styles.spacerToolbarGroup} />
                <div key="undoRedo" style={styles.undoRedoToolbarGroup}>
                {
                    this.props.onUndoClick
                    ?
                    <IconTextButton
                        style={styles.undoRedoIcon}
                        Icon={<UndoIcon />}
                        text={l10n("actionBar.undo")}
                        onTouchTap={this.props.onUndoClick}
                        dataTestId = "action-bar-btn-undo"
                        isDisabled={!this.props.undoEnabled}
                        isSecondary={true}
                    />
                    :
                    null
                }
                {
                    this.props.onRedoClick
                    ?
                    <IconTextButton
                        style={styles.undoRedoIcon}
                        Icon={<RedoIcon />}
                        text={l10n("actionBar.redo")}
                        onTouchTap={this.props.onRedoClick}
                        dataTestId = "action-bar-btn-redo"
                        isDisabled={!this.props.redoEnabled}
                        isSecondary={true}
                    />
                    :
                    null
                }
                </div>
                <div key="spacer2" style={styles.spacerToolbarGroup} />
                {
                    this.props.hasFeedbackbutton
                      ? (
                            <div key="feedback" style={styles.feedbackToolbarGroup}>
                                <FeedbackButton
                                    feedbackFeatureName={this.props.feedbackFeatureName}
                                    feedbackContext={this.props.feedbackContext}
                                    onFeedbackSubmit={this.props.onFeedbackSubmit}
                                />
                            </div>
                        )
                      : null
                }
                {
                    this.props.onHelpClick
                      ? (
                            <div key="help" style={styles.helpToolbarGroup}>
                                <IconTextButton
                                    Icon={<HelpIcon />}
                                    text={l10n("helptoolbar.title")}
                                    dataTestId = "action-bar-btn-help"
                                    onTouchTap={this.props.onHelpClick}
                                    isSecondary={true}
                                />
                            </div>
                        )
                      : null
                }
                <div key="buttons" style={styles.buttonsToolbarGroup}>
                    {this.props.buttons}
                </div>
            </Toolbar>
        );
    }

    private renderTabs() {
        return (
            <Tabs onChange={this.props.onTabChange} value={this.props.currentTab}>
                {
                    this.props.tabs.map((tab, index) => {
                        return ( <Tab key={index} label={tab.label} /> );
                    })
                }
            </Tabs>
        );
    }

    private getStyles() {
        return {
            root: Object.assign(autoprefixer({
                display: 'flex',
                alignItems: 'center' }), {
                paddingLeft: 0,
                paddingRight: 4,
                background: '#003d8f'
            }),
            logoToolbarGroup: autoprefixer({
                display: 'flex'
            }),
            logoWrapper: {
                backgroundColor: 'transparent',
                padding: 11,
                marginRight: 8
            },
            logo: {
                height: 34
            },
            title: {
                fontSize: 14,
                paddingLeft: 12,
            },
            spacerToolbarGroup: autoprefixer({
                flexGrow: 1
            }),
            undoRedoToolbarGroup: autoprefixer({
                display: 'flex'
            }),
            undoRedoIcon: {
                marginRight: 12
            },
            feedbackToolbarGroup: Object.assign(autoprefixer({
                display: 'flex' }), {
                marginRight: 4
            }),
            helpToolbarGroup: autoprefixer({
                display: 'flex'
            }),
            buttonsToolbarGroup: autoprefixer({
                display: 'flex'
            })
        };
    }

}

export default ActionBarToolbar;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/actionBar/components/ActionBarToolbar.tsx
 **/